<template>
  <div class="earth-container">
    <div v-for="(item, index) in picLists" :key="index" :class="picSign[index]">
      <span class="text">{{ item.sceneName }}</span>
      <img :src="item.mainImg" class="pic" @click="handleScene(item)" />
    </div>
  </div>
</template>

<script>
export default {
  props: {
    picList: {
      default: () => [],
      type: Array
    }
  },
  data () {
    return {
      picSign: ['front', 'back', 'left', 'right', 'top', 'bottom'],
      picLists: []
    }
  },
  mounted () {
    let deepCloneList = JSON.parse(JSON.stringify(this.picList))
    if (deepCloneList.length > 6) {
      this.picLists = deepCloneList.slice(0, 6)
    } else if (deepCloneList.length < 6) {
      while (deepCloneList.length < 6) {
        const random = Math.floor(Math.random() * deepCloneList.length)
        deepCloneList.push(deepCloneList[random])
      }
      this.picLists = deepCloneList
    } else {
      this.picLists = deepCloneList
    }
  },
  methods: {
    handleScene (item) {
      this.$router.push({ name: 'Scene', query: { sceneId: item.sceneId } })
    }
  }
}
</script>

<style lang="scss" scoped>
.earth-container {
  width: 120px;
  height: 120px;
  transform: rotateY(15deg) rotateX(-15deg);
  transform-style: preserve-3d;
  animation: xuanzhuan 16s linear infinite;

  &:hover {
    animation-play-state: paused;
  }
}

@keyframes xuanzhuan {
  0% {
    transform: rotateY(15deg) rotateX(45deg);
  }
  50% {
    transform: rotateY(375deg) rotateX(-45deg);
  }
  100% {
    transform: rotateY(735deg) rotateX(45deg);
  }
}

.earth-container div.front {
  background: white;
  transform: translateZ(60px);
}

.earth-container div.back {
  background: white;
  transform: translateZ(-60px) rotateY(180deg);
}

.earth-container div.left {
  background: white;
  transform: translateX(-60px) rotateY(-90deg);
}

.earth-container div.right {
  background: white;
  transform: translateX(60px) rotateY(90deg);
}

.earth-container div.top {
  background: white;
  transform: translateY(-60px) rotateX(90deg);
}

.earth-container div.bottom {
  background: white;
  transform: translateY(60px) rotateX(-90deg);
}

.earth-container div {
  position: absolute;
  left: 0;
  top: 0;
  width: 120px;
  height: 120px;
  line-height: 120px;
  text-align: center;
  font-size: 0;
  cursor: pointer;

  &:hover {
    .text {
      color: #fff;
    }
  }
}

.earth-container .pic {
  width: 120px;
  height: 120px;
  object-fit: cover;
}

.earth-container .text {
  position: absolute;
  left: 50%;
  top: 50%;
  -webkit-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
  font-size: 14px;
  line-height: 16px;
  color: #3d88d4;
  width: 100%;
  -webkit-user-select: none;
  user-select: none;
  pointer-events: none;
}
</style>
